import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const orderGet = async (order_status_id) => {
  try {
    const res = await getData(`/useraddress/orderget?order_status_id=${order_status_id}`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const returnOrderGet = async () => {
  try {
    const res = await getData(`/useraddress/order-return`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const OrderCancel = async (data) => {
  try {
    const res = await postData(`/useraddress/order-cancel`, data);
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const orderReturn = async (data) => {
  try {
    const res = await postData(`/useraddress/order-return`, data);
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const singleOrderGet = async (id) => {
  try {
    const res = await getData(`/useraddress/orderget/${id}`);
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const UserGet = async () => {
  try {
    const res = await getData(`/auth/user-get`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const UserEdit = async (data) => {
  try {
    const res = await postData(`/admin/userEdit`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const ChangePassword = async (data) => {
  try {
    const res = await postData(`/admin/change-password`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const ChangePasswordWL = async (data) => {
  try {
    const res = await postData(`/admin/change-password-wl`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const CheckExist = async (data) => {
  try {
    const res = await postData(`/admin/check-exist`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const emailOtpGet = async (data) => {
  try {
    const res = await postData(
      `/without-login/verify-otp/email-otp-send`,
      data
    );

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const emailOtpVerify = async (data) => {
  try {
    const res = await postData(`/without-login/otp/email-verify-otp`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};


export const getAllNotification = async () => {
  try {
    const res = await getData(`/notification`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getNotificationCount = async () => {
  try {
    const res = await getData(`/notification//notification-count`);

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const SeeNotification = async () => {
  try {
    const res = await postData(`/notification/see-notification`);

    return res;
  } catch (error) {
    console.log(error);
  }
};
